module.exports = __webpack_public_path__ + "static/media/31drewtrevorintro.6c7405f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/31drewtrevorintro.png
// module id = 126
// module chunks = 0